import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=7a83d137"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"
import style0 from "./EmailView.vue?vue&type=style&index=0&id=7a83d137&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports